import { focusManager, onlineManager } from '@tanstack/query-core';

function isTabVisible(): boolean {
  return document.visibilityState !== 'hidden';
}

const doNothingOnNetworkChange = (): void => undefined;

function startWatchingTheNetworkBeforeTheFirstRender(): void {
  onlineManager.subscribe(doNothingOnNetworkChange);
}

export function installBrowserActivitySources(): void {
  onlineManager.setOnline(navigator.onLine !== false);
  focusManager.setFocused(isTabVisible());
  startWatchingTheNetworkBeforeTheFirstRender();

  focusManager.setEventListener((setFocused) => {
    const trackVisibility = (): void => setFocused(isTabVisible());

    const trackRestoredPage = (event: PageTransitionEvent): void => {
      if (!isTabVisible()) {
        return;
      }
      if (event.persisted && focusManager.isFocused()) {
        setFocused();
        return;
      }

      setFocused(true);
    };

    document.addEventListener('visibilitychange', trackVisibility);
    window.addEventListener('pageshow', trackRestoredPage);

    return () => {
      document.removeEventListener('visibilitychange', trackVisibility);
      window.removeEventListener('pageshow', trackRestoredPage);
    };
  });
}
